import { LayoutCardVariantType } from '../../../../../../components/layoutCard/types/layoutCardVariantType';
import { layoutCardContainerCommonStyles, layoutCardContainerFirstChildCommonStyles, layoutCardContentContainerCommonStyles, } from '../commonStyles';
export const getMainContent4ColumnsStyles = (FOUNDATIONS, FONT) => {
    return {
        [LayoutCardVariantType.MAIN_CONTENT_4_COLUMNS]: {
            layoutCardContainer: {
                ...layoutCardContainerCommonStyles(FOUNDATIONS, FONT),
                grid_template_columns: 'repeat(8, 1fr)',
            },
            layoutCardContainerFirstChild: {
                ...layoutCardContainerFirstChildCommonStyles(FOUNDATIONS, FONT),
            },
            layoutCardContentContainer: {
                ...layoutCardContentContainerCommonStyles(FOUNDATIONS, FONT),
                grid_column_start: '3',
                grid_column_end: '7',
            },
        },
    };
};
//# sourceMappingURL=mainContent4Columns.js.map